import { Globals } from "../CoreApp/Globals";

// enlarge a sub-chart arrow dimension so it stays tappable on mobile; no-op for public/print views
const TOUCH_ARROW_SCALE = 1.1;

export function ScaleSCArrowForTouch(dimension: number, pub?: boolean): number {
  if (!Globals._mobileDevice || pub) return dimension;

  const sf = Globals._wsMgr?.fCanvasPanel ? Globals._wsMgr.fCanvasPanel.GetScaleFactor() : 1;
  let scaled = dimension * TOUCH_ARROW_SCALE;
  if (sf < 1) scaled = scaled / Math.sqrt(sf);
  return scaled;
}
